<input
  class="numeric-input"
  type="number"
  autocomplete="off"
  [class.review-input-error-border]="error"
  [min]="min"
  [max]="max"
  [attr.id]="controlId"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)" />
